const STRIPE_PAYMENT_METHODS = {
  ACSS_DEBIT: 'acss_debit',
  AFFIRM: 'affirm',
  AFTERPAY_CLEARPAY: 'afterpay_clearpay',
  ALIPAY: 'alipay',
  AMAZON_PAY: 'amazon_pay',
  AU_BECS_DEBIT: 'au_becs_debit',
  BACS_DEBIT: 'bacs_debit',
  BANCONTACT: 'bancontact',
  BLIK: 'blik',
  BOLETO: 'boleto',
  CARD: 'card',
  CARD_PRESENT: 'card_present',
  CASHAPP: 'cashapp',
  CUSTOMER_BALANCE: 'customer_balance',
  EPS: 'eps',
  FPX: 'fpx',
  GIROPAY: 'giropay',
  GRABPAY: 'grabpay',
  IDEAL: 'ideal',
  INTERAC_PRESENT: 'interac_present',
  KLARNA: 'klarna',
  KONBINI: 'konbini',
  LINK: 'link',
  MOBILEPAY: 'mobilepay',
  MULTIBANCO: 'multibanco',
  OXXO: 'oxxo',
  P24: 'p24',
  PAYNOW: 'paynow',
  PAYPAL: 'paypal',
  PIX: 'pix',
  PROMPTPAY: 'promptpay',
  REVOLUT_PAY: 'revolut_pay',
  SEPA_DEBIT: 'sepa_debit',
  SOFORT: 'sofort',
  SWISH: 'swish',
  TWINT: 'twint',
  US_BANK_ACCOUNT: 'us_bank_account',
  WECHAT_PAY: 'wechat_pay',
  ZIP: 'zip',
};

export default STRIPE_PAYMENT_METHODS;
